import { render, staticRenderFns } from "./MoreDealCollapseTheme0.vue?vue&type=template&id=0864c6ea&scoped=true"
import script from "./MoreDealCollapseTheme0.vue?vue&type=script&lang=js"
export * from "./MoreDealCollapseTheme0.vue?vue&type=script&lang=js"
import style0 from "./MoreDealCollapseTheme0.vue?vue&type=style&index=0&id=0864c6ea&prod&lang=css"
import style1 from "./MoreDealCollapseTheme0.vue?vue&type=style&index=1&id=0864c6ea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0864c6ea",
  null
  
)

export default component.exports